import { render, staticRenderFns } from "./BackgroundComponent.vue?vue&type=template&id=e883cb96"
import script from "./BackgroundComponent.vue?vue&type=script&lang=js"
export * from "./BackgroundComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports